/**
 * @generated SignedSource<<783c36519baf864cd6bded1577a6a6d7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedAddToCartButton_item$data = {
  readonly defaultSkuId: string;
  readonly serviceId: string | null;
  readonly " $fragmentType": "PdpSharedAddToCartButton_item";
};
export type PdpSharedAddToCartButton_item$key = {
  readonly " $data"?: PdpSharedAddToCartButton_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAddToCartButton_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedAddToCartButton_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "defaultSkuId",
        "storageKey": null
      },
      "action": "THROW",
      "path": "defaultSkuId"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "d396c22347694efc73ea407c0e5684ab";

export default node;
